import type { QueryKey } from '@tanstack/query-core';
import type { ClientStoreClientOptions } from './client-store-client-options';

export interface QueryInvalidationOptions extends ClientStoreClientOptions {
    dedupe?: boolean;
    /** @deprecated Use `dedupe` instead. Debounce will be removed in a future version. */
    debounce?: boolean;
    invalidationKey?: QueryKey;
}
